import axios, { AxiosError } from "axios";
import * as H from "history";
import { toast } from "react-toastify";
import config from "../../config";
import { dataTransformer } from "./AxiosInterceptor";


export const axiosWSPInstance = axios.create({
    baseURL: config.wspApiUrl,
    withCredentials: true,
    transformRequest: [dataTransformer].concat(axios.defaults.transformRequest!),
})


export const WSPInterceptors = {
    setupCoreTokenInterceptor: () => {
        axiosWSPInstance.interceptors.request.use((config) => {
            const token = localStorage.getItem("coreToken");
            config.headers!['Authorization'] = `Bearer ${token}`;
            return config;
        })
    },
    setupUnauthorizedCoreInterceptor: (history: H.History) => {
        axiosWSPInstance.interceptors.response.use(response => response, (error) => {
            const response = (error as AxiosError).response;
            if (response) {
                const { data, status } = response!; //We are adding the ! because we know we will have a error response here
                switch (status) {
                    case 400:
                        if (data.ModelState) {
                            const modelStateErrors: string[] = [];
                            for (const key in data.ModelState) {
                                if (data.ModelState[key]) {
                                    modelStateErrors.push(data.ModelState[key]);
                                }
                            }
                            throw modelStateErrors.flat();
                        }
                        toast.error(data.Message);
                        break;
                    case 401:
                        history.push('/login');
                        break;
                    case 403:
                        break;
                    case 404:
                        if (data) {
                            toast.error(data);
                        } else {
                            toast.error('Not found');
                        }
                        break;
                    case 422:
                        if (data){
                            toast.error(data);
                        }
                        break;
                    case 500:
                        toast.error('Server error - Please Contact BEE123');
                        break;
                }
            }
            return Promise.reject(error);
        });
    },
}